<template>
  <div>
    <table>
      <tbody>
      <tr>
        <th><p>부가세</p></th>
        <td>{{vat | numberFormat}} 원</td>
      </tr>
      </tbody>
    </table>
    <div class="total-pay">
      <h3 class="w-blue-text">결제 예상 금액</h3>
      <p class="pay">
        <strong class="w-blue-text">{{totalPrice | numberFormat}} 원</strong>
      </p>
    </div>
    <p class="btn-payment"><button class="hw-pill-button small w-100" @click="goToNext">다음 단계</button></p>
    <p class="btn-payment bordered lib-mt-10">
      <button class="hw-pill-button bordered small w-100" @click="showEstimate">견적서 출력</button>
    </p>
    <form method="POST"
          :action="paymentActionUrl"
          ref="payment-form"
    >
      <input type="hidden" name="payment_seq" :value="orderInfo.seqno"/>
    </form>
  </div>
</template>

<script>
import {mapGetters, mapState, mapActions} from 'vuex'
import sitesInfo from "@/js/helper/sites-info";

export default {
  name: "CalculateResult",
  data(){
    return {
      orderInfo : {
        order_number : null,
        payment_status : null,
        seqno : null,
        valid_date : null,
      }
    }
  },
  computed: {
    ...mapGetters({
      totalPrice : 'order_info/getTotalPrice',
      vat : 'order_info/getVat',
      domainType: 'goods_info/getDomainType',
    }),
    ...mapState({
      clauseCompositionList: state => state['goods_info']['package_info']['clause_composition'],
      checkedClauseCompositionList: state => state['order_info']['checkedClauseCompositionList'],
      domain: state => state['order_info']['domain'],
    }),
    paymentActionUrl(){
      return sitesInfo.wwwHiworks + '/market/payform_v3'
    },
  },
  methods: {
    ...mapActions({
      orderRequest : 'order_info/orderRequest',
      setLoading : 'setLoading'
    }),
    showEstimate(){
      this.$emit('show-estimate',{
        name: '_blank',
        specs: [
          
        ],
        styles: [
          './step1.css'
        ]
      })
    },
    goToNext(){
      if(this.domainType === "Y" && !this.domain){
        alert('도메인 체크는 필수입니다')
        document.getElementById("domain-check").focus()
        return
      }
      if(this.clauseCompositionList.length !== this.checkedClauseCompositionList.length){
        alert('이용 약관에 동의해야 서비스를 신청할 수 있습니다.\n이용 약관을 확인하세요.')
        document.getElementById("agreement").focus()
        return
      }

      this.setLoading(true)
      this.orderRequest()
      .then(apiResponse => {
        if(apiResponse.data.checkout){
          let orderInfo = apiResponse.data.checkout
          this.orderInfo = orderInfo
          this.$nextTick(()=>{
            this.$refs['payment-form'].submit()
          })
        } else{
          alert('주문서 생성 중 오류가 발생했습니다.')
          this.setLoading(false)
        }
      })
      .catch(()=>{
        alert('주문서 생성 중 오류가 발생했습니다.')
        this.setLoading(false)
      })

    }
  }
}
</script>

<style scoped>
.total-pay {
  padding: 60px 0 20px;
  font-size: 14px;
  color: #3090D6;
  text-align: right;
.pay {
  font-size: 30px;
}
}
</style>